<template>
    <div class="w-100 d-flex flex-column">
        <b-row align-v="center">
            <b-col>
                <b-nav class="user-panel-nav-tabs">
                    <b-nav-item :to="{name: 'MonthlyPayment'}"
                                active-class="active">
                        Monthly payment table
                    </b-nav-item>
                    <b-nav-item :to="{name: 'WarehousingFees'}"
                                active-class="active">
                        Warehousing Fees
                    </b-nav-item>
                    <b-nav-item :to="{name: 'Refunds'}"
                                active-class="active">
                        Refunds
                    </b-nav-item>
                    <b-nav-item :to="{name: 'Invoices'}"
                                active-class="active">
                        Invoices
                    </b-nav-item>
                </b-nav>
            </b-col>
        </b-row>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: 'MainPayments',
        data() {
            return {}
        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/UserPanel/Pages/Reports/Payments/MainPayments.vue